import {
  getColor,
  getContentProps,
  I_ContentMeta,
  I_AdBanner,
  getAdBanner,
} from '../../../common/state/apiGet';
import {IBigContent} from '../../../commonSub/type';
import {HomeTabPage} from '../../common/type';
import {
  IContentListByDay,
  ITimeTableContent,
  ITimeTableGenreItem,
} from '../type';

interface I_Additional {
  // 앵커 카드 라벨링 노출을 위한 필드로 사용.
  anchor?: boolean;
  label?: string;
  labelBackgroundColor?: string;
  isSubscription?: boolean;
}

interface I_TimeTableSection {
  advertisement?: I_AdBanner;
  placement: string;
  cardGroups: Array<{
    cards: I_TimeTableCard[];
  }>;
}

interface I_TimeTableCard {
  id: string;
  content: I_ContentMeta;
  additional?: I_Additional;
}

interface I_TimeTableGenre {
  label: string;
  genre: string;
  placement: string;
}

function getBigContent(item: I_TimeTableCard) {
  const {id, content, additional} = item;
  const {
    label,
    labelBackgroundColor,
    isSubscription = false,
    // 신작 탭은 이 필드가 없어서 라벨 노출 X, 그 외 탭에서는 데이터 보장이 되기 때문에 기본 값을 true 로 변경
    anchor: showLabel = true,
  } = additional ?? {};
  return {
    ...getContentProps(
      content,
      [
        'id',
        'sid',
        'title',
        'descLine2',
        'descLine3',
        'mainImg',
        'mainTitleImg',
        'bgImg',
        'badges',
        'authors',
        'motionVideo',
        'motionStartImg',
        'isAdult',
        'seoKeywords',
      ],
      {isBigBg: true}
    ),
    label:
      showLabel && label && labelBackgroundColor
        ? {
            text: label,
            bgColor: getColor(labelBackgroundColor),
          }
        : undefined,
    cardId: id,
    isLike: isSubscription,
  };
}

export function getNewContents(data: I_TimeTableSection[]): IBigContent[] {
  const list = data?.[0].cardGroups?.[0]?.cards || [];
  return list.map(item => getBigContent(item));
}

export function getCompleteContents(data: I_TimeTableSection[] = []): {
  bigContent?: IBigContent;
  contents: ITimeTableContent[];
} {
  const [anchorContent, ...otherContents] =
    data?.[0].cardGroups?.[0]?.cards || [];
  return {
    bigContent: getBigContent(anchorContent),
    contents: otherContents.map(item => ({
      ...getContentProps(item.content, [
        'id',
        'sid',
        'title',
        'thumbImg',
        'titleImg',
        'bgColorRgb',
        'bgImg',
        'badges',
        'isAdult',
      ]),
      cardId: item.id,
    })),
  };
}

export function getCompletedGenres(
  webtoonGenres: I_TimeTableGenre[] = []
): ITimeTableGenreItem[] {
  return webtoonGenres.map(item => ({
    key: item.placement,
    genre: item.genre,
    text: item.label,
  }));
}

export function getDayContent({
  advertisement,
  cardGroups = [],
  placement,
}: I_TimeTableSection): IContentListByDay {
  const [anchorContent, ...otherContents] = cardGroups.reduce<
    I_TimeTableCard[]
  >((prev, current) => [...prev, ...(current?.cards || [])], []);
  const bigContent = getBigContent(anchorContent);
  const contents = otherContents.map(({id, content}) => ({
    ...getContentProps(content, [
      'id',
      'sid',
      'title',
      'thumbImg',
      'titleImg',
      'bgColorRgb',
      'bgImg',
      'badges',
      'anchorClip',
      'isAdult',
    ]),
    cardId: id,
  }));
  return {
    bigContent,
    contents,
    placement,
    talkBoard: getAdBanner({
      page: HomeTabPage.TimeTable,
      data: advertisement,
      needDefaultType: true,
    }),
  };
}
